<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from './provider.js';
import { hasOneDayPassed } from 'shared/helpers/timeHelper';
import { ORIENTATION, MESSAGE_STATUS } from './constants';

defineProps({
  error: { type: String, required: true },
});

const emit = defineEmits(['retry', 'cancel', 'delete']);

const { orientation, status, createdAt, content, attachments } =
  useMessageContext();

const canRetry = computed(() => {
  const hasContent = content.value !== null;
  const hasAttachments = attachments.value && attachments.value.length > 0;
  return !hasOneDayPassed(createdAt.value) && (hasContent || hasAttachments);
});

const deliveryHelpText = computed(() => {
  const retryText = canRetry.value
    ? 'Voce pode reenviar, cancelar o envio ou apagar a mensagem.'
    : 'Reenvio indisponivel para mensagens com mais de 24 horas.';

  return `Nao entregue: a Meta/WhatsApp nao confirmou o envio. ${retryText} Detalhe: ${error}`;
});
</script>

<template>
  <div class="text-xs text-n-ruby-11 flex items-center gap-1.5">
    <span>Nao entregue</span>
    <div class="relative group">
      <div
        class="bg-n-alpha-2 rounded-md size-5 grid place-content-center cursor-pointer"
      >
        <Icon
          icon="i-lucide-alert-triangle"
          class="text-n-ruby-11 size-[14px]"
        />
      </div>
      <div
        class="absolute bg-n-alpha-3 px-4 py-3 border rounded-xl border-n-strong text-n-slate-12 bottom-6 w-72 text-xs backdrop-blur-[100px] shadow-[0px_0px_24px_0px_rgba(0,0,0,0.12)] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all break-words"
        :class="{
          'ltr:left-0 rtl:right-0': orientation === ORIENTATION.LEFT,
          'ltr:right-0 rtl:left-0': orientation === ORIENTATION.RIGHT,
        }"
      >
        {{ deliveryHelpText }}
      </div>
    </div>
    <div v-if="canRetry" class="flex items-center gap-1">
      <button
        type="button"
        :disabled="status !== MESSAGE_STATUS.FAILED"
        class="bg-n-alpha-2 rounded-md px-2 h-5 grid place-content-center cursor-pointer text-[11px]"
        title="Reenviar mensagem"
        @click="emit('retry')"
      >
        Reenviar
      </button>
      <button
        type="button"
        :disabled="status !== MESSAGE_STATUS.FAILED"
        class="bg-n-alpha-2 rounded-md px-2 h-5 grid place-content-center cursor-pointer text-[11px]"
        title="Cancelar envio"
        @click="emit('cancel')"
      >
        Cancelar
      </button>
      <button
        type="button"
        :disabled="status !== MESSAGE_STATUS.FAILED"
        class="bg-n-alpha-2 rounded-md px-2 h-5 grid place-content-center cursor-pointer text-[11px]"
        title="Apagar mensagem"
        @click="emit('delete')"
      >
        Apagar
      </button>
    </div>
  </div>
</template>
